//#region dependencies
import React from "react";
import Icon from "@material-ui/core/Icon";
//#endregion
//#region icons svg
import HomeIconSvg from "../../../../images/home-icon.svg";
import SearchIconSvg from "../../../../images/search-icon.svg";
import ListIconSvg from "../../../../images/list-icon.svg";
import ListsIconSvg from "../../../../images/lists-icon.svg";
import RssIconSvg from "../../../../images/rss-icon.svg";
import TrackIconSvg from "../../../../images/track-icon.svg";
import ChartIconSvg from "../../../../images/chart-icon.svg";
import DataIconSvg from "../../../../images/data-icon.svg";
import RecentlyIconSvg from "../../../../images/recently-icon.svg";
import NotificationsIconSvg from "../../../../images/notifications-icon.svg";
import SettingsIconSvg from "../../../../images/setting-icon.svg";
import TrashIconSvg from "../../../../images/trash-icon.svg";
import FilterIconSvg from "../../../../images/filter-icon.svg";
import BellIconSvg from "../../../../images/bell-icon.svg";
import EditColumnsSvg from "../../../../images/edit-columns-normal.svg";
import EditColumnsBlueSvg from "../../../../images/edit-columns-blue.svg";
import FolderIconSvg from "../../../../images/folder-icon.svg";
import EducationIconSvg from "../../../../images/education-icon.svg";
import EmploymentIconSvg from "../../../../images/employment-icon.svg";
import PassionInterestsIconSvg from "../../../../images/passions-interests-icon.svg";
import AffiliatedCitiesIconSvg from "../../../../images/affiliated-cities-icon.svg";
import BoardAffiliationsIconSvg from "../../../../images/board-affiliations-icon.svg";
import CharitiesIconSvg from "../../../../images/charities-icon.svg";
import DesignationsIconSvg from "../../../../images/designations-icon.svg";
import SocietalAffiliationsIconSvg from "../../../../images/societal-affiliations-icon.svg";
import AffinityIconSvg from "../../../../images/affinity-breakdown-icon.svg";
import PermissionSummaryIconSvg from "../../../../images/permission-summary-icon.svg";
import UserDataIconSvg from "../../../../images/user-data-icon.svg";
import DataSharingPreferencesIconSvg from "../../../../images/data-sharing-preferences-icon.svg";
import CrmTrackingIconSvg from "../../../../images/crm-tracking-icon.svg";
import DataManagementIconSvg from "../../../../images/data-management-icon.svg";
import ShareMentionIconSvg from "../../../../images/share-mention-icon.svg";
import InvestorContactIconSvg from "../../../../images/investor-contact-icon.svg";
import PwgFilterIconSvg from "../../../../images/pwg_filter_icon.svg";
import ClientsIconSvg from "../../../../images/contacts-icon.svg";
import FavoriteListIconSvg from "../../../../images/favorite-list-icon.svg";
import AlertNotificationIconSvg from "../../../../images/alert-notification-icon.svg";
import FilledVerifiedIconSvg from "../../../../images/filled-verified-icon.svg";
import OutlinedVerifiedIconSvg from "../../../../images/outlined-verified-icon.svg";
import UnselectedAffintyIconSvg from "../../../../images/unselected-affinity-icon.svg";
import SelectedAffintyIconSvg from "../../../../images/selected-affinity-icon.svg";
import AccountsAndAumSvg from "../../../../images/similar-investments-fo.svg";
import FirmInfoFiltersIconSvg from "../../../../images/firm-info-filters-icon.svg";
import InvestmentFiltersIconSvg from "../../../../images/investment-details-icon.svg";
import FirmsIconSvg from "../../../../images/firms-icon.svg"
import FirmsInfoIconSvg from "../../../../images/firm-info-icon.svg"
import EmailsIconSvg from "../../../../images/emails-icon.svg"
import PhoneIconSvg from "../../../../images/phone-icon.svg"
import LinkedInIconSvg from "../../../../images/linkedin-icon.svg"
import AllocationsIconSvg from "../../../../images/allocations-icon.svg"
import PrivateFundsIconSvg from "../../../../images/private-funds-icon.svg"
import DataEnrichmentIconSvg from "../../../../images/data-enrichment-icon.svg"
import CustodiansIconSvg from "../../../../images/custodians-icon.svg"
import HubspotIconSvg from "../../../../images/hubspot-icon.svg"
import HubspotIconOffSvg from "../../../../images/hubspot-icon-off.svg"
import DynamicsIconSvg from "../../../../images/dynamics-popper-icon.svg"
import DynamicsIconOffSvg from "../../../../images/dynamics-popper-icon-off.svg"
import PeopleIconSvg from "../../../../images/people-icon.svg"
import InvertedPeopleIconSvg from "../../../../images/inverted-people-icon.svg"
import NotesIconSvg from "../../../../images/notes-icon.svg";
import OfficeLocationIconSvg from "../../../../images/office-location-icon.svg";
import ContactBioIconSvg from "../../../../images/contact-bio-icon.svg";
import ContactAdditionalNotesIconSvg from "../../../../images/contact-additional-notes-icon.svg";
import RelationshipPathIconSvg from "../../../../images/relationship-path.svg";
import InNetworkIconSvg from "../../../../images/in-network.svg";
import NotInNetworkIconSvg from "../../../../images/not-in-network.svg";
import NotInNetworkHoverIconSvg from "../../../../images/not-in-network-hover.svg";
import BuildingIconSvg from "../../../../images/building-icon-thick.svg";

//#endregion

const IconRef = (iFile) => (
  <Icon className="icon">
    <img src={iFile} />
  </Icon>
);

const SpecialIconRef = (iFile, width = '30px') => (
    <Icon className="icon">
      <img style={{width}} src={iFile} />
    </Icon>
);

const HomeIcon = () => IconRef(HomeIconSvg);
const SearchIcon = () => IconRef(SearchIconSvg);
const ListIcon = () => IconRef(ListIconSvg);
const ListsIcon = () => IconRef(ListsIconSvg);
const RssIcon = () => IconRef(RssIconSvg);
const TrackIcon = () => IconRef(TrackIconSvg);
const ChartIcon = () => IconRef(ChartIconSvg);
const DataIcon = () => IconRef(DataIconSvg);
const RecentlyIcon = () => IconRef(RecentlyIconSvg);
const NotificationsIcon = () => IconRef(NotificationsIconSvg);
const SettingsIcon = () => IconRef(SettingsIconSvg);
const TrashIcon = () => IconRef(TrashIconSvg);
const FilterIcon = () => IconRef(FilterIconSvg);
const BellIcon = () => IconRef(BellIconSvg);
const EditColumnsIcon = () => IconRef(EditColumnsSvg);
const EditColumnsBlueIcon = () => IconRef(EditColumnsBlueSvg);
const FolderIconIcon = () => IconRef(FolderIconSvg);
const EducationIcon = () => IconRef(EducationIconSvg);
const EmploymentIcon = () => IconRef(EmploymentIconSvg);
const PassionInterestsIcon = () => IconRef(PassionInterestsIconSvg);
const AffiliatedCitiesIcon = () => IconRef(AffiliatedCitiesIconSvg);
const BoardAffiliationsIcon = () => IconRef(BoardAffiliationsIconSvg);
const CharitiesIcon = () => IconRef(CharitiesIconSvg);
const DesignationsIcon = () => IconRef(DesignationsIconSvg);
const SocietalAffiliationsIcon = () => IconRef(SocietalAffiliationsIconSvg);
const AffinityIcon = () => IconRef(AffinityIconSvg);
const CustodiansIcon = () => IconRef(CustodiansIconSvg);
const HubspotIcon = () => IconRef(HubspotIconSvg);
const HubspotIconOff = () => IconRef(HubspotIconOffSvg);
const DynamicsIcon = () => IconRef(DynamicsIconSvg);
const DynamicsIconOff = () => IconRef(DynamicsIconOffSvg);
const DataManagementIcon = () => IconRef(DataManagementIconSvg);
const PermissionSummaryIcon = () => IconRef(PermissionSummaryIconSvg);
const UserDataIcon = () => IconRef(UserDataIconSvg);
const DataSharingPreferencesIcon = () => IconRef(DataSharingPreferencesIconSvg);
const CrmTrackingIcon = () => IconRef(CrmTrackingIconSvg);
const ShareMentionIcon = () => IconRef(ShareMentionIconSvg);
const InvestorContactIcon = () => IconRef(InvestorContactIconSvg);
const PwgFilterIcon = () => IconRef(PwgFilterIconSvg);
const FavoriteListIcon = () => IconRef(FavoriteListIconSvg);
const AlertNotificationIcon = () => IconRef(AlertNotificationIconSvg);
const FilledVerifiedIcon = () => IconRef(FilledVerifiedIconSvg);
const OutlinedVerifiedIcon = () => IconRef(OutlinedVerifiedIconSvg);
const UnselectedAffintyIcon = () => IconRef(UnselectedAffintyIconSvg);
const SelectedAffintyIcon = () => IconRef(SelectedAffintyIconSvg);
const ClientsIcon = () => IconRef(ClientsIconSvg);
const AccountsAndAum = () => IconRef(AccountsAndAumSvg);
const FirmInfoFiltersIcon = () => IconRef(FirmInfoFiltersIconSvg);
const InvestmentFiltersIcon = () => IconRef(InvestmentFiltersIconSvg);
const FirmsIcon = () => IconRef(FirmsIconSvg)
const FirmsInfoIcon = () => IconRef(FirmsInfoIconSvg)
const EmailsIcon = () => IconRef(EmailsIconSvg)
const PhoneIcon = () => IconRef(PhoneIconSvg)
const LinkedInIcon = () => IconRef(LinkedInIconSvg)
const AllocationsIcon = () => IconRef(AllocationsIconSvg)
const PrivateFundsIcon = () => IconRef(PrivateFundsIconSvg)
const DataEnrichmentIcon = () => IconRef(DataEnrichmentIconSvg)
const IntegrationsSectionIcon = () => IconRef(DataSharingPreferencesIconSvg)
const NotesIcon = () => IconRef(NotesIconSvg);
const OfficeLocationIcon = () => IconRef(OfficeLocationIconSvg);
const ContactBioIcon = () => IconRef(ContactBioIconSvg);
const ContactAdditionalNotesIcon = () => IconRef(ContactAdditionalNotesIconSvg);
const NetworkIcon = () => SpecialIconRef(PeopleIconSvg)
const InvertedNetworkIcon = () => SpecialIconRef(InvertedPeopleIconSvg, "27px")
const RelationshipPathIcon = () => IconRef(RelationshipPathIconSvg)
const InNetworkIcon = () => IconRef(InNetworkIconSvg)
const NotInNetworkIcon = () => IconRef(NotInNetworkIconSvg)
const NotInNetworkHoverIcon = () => IconRef(NotInNetworkHoverIconSvg)
const BuildingIcon = () => IconRef(BuildingIconSvg)

export {
  HomeIcon,
  SearchIcon,
  ListIcon,
  ListsIcon,
  RssIcon,
  TrackIcon,
  ChartIcon,
  DataIcon,
  RecentlyIcon,
  NotificationsIcon,
  SettingsIcon,
  TrashIcon,
  FilterIcon,
  NetworkIcon,
  InvertedNetworkIcon,
  BellIcon,
  EditColumnsIcon,
  EditColumnsBlueIcon,
  FolderIconIcon,
  EducationIcon,
  EmploymentIcon,
  PassionInterestsIcon,
  AffiliatedCitiesIcon,
  BoardAffiliationsIcon,
  CharitiesIcon,
  DesignationsIcon,
  SocietalAffiliationsIcon,
  AffinityIcon,
  PermissionSummaryIcon,
  UserDataIcon,
  DataSharingPreferencesIcon,
  CrmTrackingIcon,
  DataManagementIcon,
  ShareMentionIcon,
  InvestorContactIcon,
  PwgFilterIcon,
  FavoriteListIcon,
  AlertNotificationIcon,
  FilledVerifiedIcon,
  OutlinedVerifiedIcon,
  UnselectedAffintyIcon,
  SelectedAffintyIcon,
  ClientsIcon,
  AccountsAndAum,
  FirmInfoFiltersIcon,
  InvestmentFiltersIcon,
  FirmsIcon,
  FirmsInfoIcon,
  EmailsIcon,
  PhoneIcon,
  LinkedInIcon,
  AllocationsIcon,
  PrivateFundsIcon,
  DataEnrichmentIcon,
  CustodiansIcon,
  HubspotIcon,
  HubspotIconOff,
  DynamicsIcon,
  DynamicsIconOff,
  IntegrationsSectionIcon,
  NotesIcon,
  OfficeLocationIcon,
  ContactBioIcon,
  ContactAdditionalNotesIcon,
  RelationshipPathIcon,
  InNetworkIcon,
  NotInNetworkIcon,
  NotInNetworkHoverIcon,
  BuildingIcon,
};
